import TreatmentsAndDate from '../pages/01.treatments-and-date/treatments-and-date.vue'
import ItinerarySelection from '../pages/02.itinerary-selection/itinerary-selection.vue'
import SpaCheckout from '../pages/03.spa-checkout/spa-checkout.vue'

export const SPA_SOFT_ROUTE_NAMES = Object.freeze({
  ROOT: '/spa-soft',
  SPA_SOFT_TREATMENTS_AND_DATE: 'spa-soft-treatments-and-date',
  SPA_SOFT_ITINERARY_SELECTION: 'spa-soft-itinerary-selection',
  SPA_SOFT_CHECK_OUT: 'spa-soft-check-out'
})

export const spaSoftRoutes = [
  { path: `${SPA_SOFT_ROUTE_NAMES.ROOT}`, component: TreatmentsAndDate, name: SPA_SOFT_ROUTE_NAMES.SPA_SOFT_TREATMENTS_AND_DATE },
  { path: `${SPA_SOFT_ROUTE_NAMES.ROOT}/itinerary-selection`, component: ItinerarySelection, name: SPA_SOFT_ROUTE_NAMES.SPA_SOFT_ITINERARY_SELECTION },
  { path: `${SPA_SOFT_ROUTE_NAMES.ROOT}/check-out`, component: SpaCheckout, name: SPA_SOFT_ROUTE_NAMES.SPA_SOFT_CHECK_OUT },
]
